module.exports = __webpack_public_path__ + "static/media/05jouban.9cec5021.png";